import axios from 'axios';
import cfac22 from '../cfac22';

/**
 * Busca as organizações associadas a um usuário.
 * @param {string} userId - ID do usuário.
 * @param {boolean} [getOrgsInfo=false] - Se true, retorna objetos completos das organizações publicadas. Este parâmetro agora é enviado no corpo (body) da requisição.
 * @returns {Promise<Object>} Resultado da API.
 */
export async function getUserOrgs(getOrgsInfo = false) {
  try {

    const response = await axios({
      method: 'POST',
      url: `${cfac22('API_HOST_V2')}/organizations/user`,
      headers: {
        'Full-Url': window.location.href,
      },
      withCredentials: true,
      data: { getOrgsInfo },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

